
export enum JobApplicationStatus {
   
    Success = 1,
    AlreadyApplied = 2,
    JobStatusIsNotActive = 3,       
   
}